import client from '@/api/client';

export interface MediaPlanSummary {
  plan_id: string;
  campaign_count: number;
  // True when at least one campaign line in the plan is "DCO Enabled".
  // Plans can mix DCO and non-DCO lines.
  has_dco: boolean;
  channel: string | null;
  market: string | null;
  business_unit: string | null;
  year: string | null;
  quarter: string | null;
  earliest_start_date: string | null;
  latest_end_date: string | null;
}

export interface MediaPlansResponse {
  media_plans: MediaPlanSummary[];
  total_count: number;
  last_import_at: string | null;
}

export interface ApproveMediaPlanRequest {
  plan_id: string;
}

export interface ApproveMediaPlanResponse {
  success: boolean;
  plan_id: string;
  campaigns_updated: number;
  message: string;
}

export interface ValidationIssue {
  campaign_id: string | null;
  flight_group_id: string | null;
  field: string;
  message: string;
  severity: 'error' | 'warning';
}

export interface ValidationResponse {
  plan_id: string;
  is_valid: boolean;
  has_errors: boolean;
  has_warnings: boolean;
  error_count: number;
  warning_count: number;
  campaign_count: number;
  errors: ValidationIssue[];
  warnings: ValidationIssue[];
}

export async function fetchPendingMediaPlans(): Promise<MediaPlansResponse> {
  const response = await client.get<MediaPlansResponse>('/media-plans/pending');
  return response.data;
}

export async function fetchMediaPlanValidation(planId: string): Promise<ValidationResponse> {
  const response = await client.get<ValidationResponse>(`/media-plans/${planId}/validate`);
  return response.data;
}

export async function approveMediaPlan(planId: string): Promise<ApproveMediaPlanResponse> {
  const response = await client.post<ApproveMediaPlanResponse>('/media-plans/approve', {
    plan_id: planId,
  });
  return response.data;
}
